import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent as MuiDialogContent, DialogTitle, Grid as MuiGrid } from "@mzc-pdc/ui";
import { IconClose } from "@mzc-cloudplex/icons";
import TooltipButton from "@components_v2/tooltip-button/tooltip-button";
import styled from "styled-components";
import theme from "@styles/theme";
import Typography from "@components_v2/typography/typography";
import ZoomableImageViewer from "@components_v2/zoomable-image-viewer/zoomable-image-viewer";

const StyledDialogContent = styled(MuiDialogContent)`
    overflow-y: hidden;
`;

const ImagePreviewV2 = ({ onClickClose, asset, src }) => {
    const { t } = useTranslation();

    // mimeType 은 선택 필드라 비어 올 수 있다 — 없다고 버리면 프리뷰가 통째로 사라지므로 비-이미지가 확실한 것만 제외
    const imagePreviews = useMemo(
        () => (asset.previews ?? []).filter((p) => !p?.mimeType || p.mimeType.startsWith("image/")),
        [asset.previews],
    );

    return (
        <Dialog
            open
            variant={"expandable"}
            onClick={(e) => {
                if (e.target.className.includes("MuiDialog-container")) onClickClose();
                e.stopPropagation();
            }}
            onDoubleClick={(e) => {
                e.stopPropagation();
            }}
            onClose={(e) => {
                onClickClose();
            }}
            sx={{
                ".MuiDialog-paper": {
                    maxHeight: "calc(100% - 60px)",
                    maxWidth: "calc(100% - 60px)",
                    width: "100%",
                    height: "100%",
                },
            }}
        >
            <DialogTitle>
                <MuiGrid container justifyContent={"space-between"}>
                    <Typography variant={"h4"} color={theme.palette.greySecondary.main}>
                        {asset.name}
                    </Typography>
                </MuiGrid>
                <TooltipButton
                    circled
                    title={t(`common::label::Close`, `Close`)}
                    onClickButton={() => onClickClose()}
                    color={theme.palette.greySecondary.main}
                    buttonIcon={<IconClose size={20} />}
                />
            </DialogTitle>
            <StyledDialogContent>
                <ZoomableImageViewer elements={[{ previews: imagePreviews }]} asset={asset} />
            </StyledDialogContent>
        </Dialog>
    );
};

export default ImagePreviewV2;
